/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { ErrorSeverityEnum } from '@irian-ro/shared-components-module';

@Directive({
  selector: '[minTime], [wellMinTime]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MinTimeValidator,
      multi: true,
    }
  ],
  standalone: true,
})
export class MinTimeValidator implements Validator {
  @Input('minTime') time: string | null | undefined = '00:00';
  @Input() fieldName = '';

  validate(control: AbstractControl) {
    const funcProperties = {
      time: this.time,
      fieldName: this.fieldName,
    };
    return _minTimeValidation.bind(funcProperties)(control);
  }
}

export const minTimeValidation = (time = '00:00', fieldName = ''): ValidatorFn => {
  const funcProperties = {
    time: time,
    fieldName: fieldName,
  };

  return _minTimeValidation.bind(funcProperties);
};

function _minTimeValidation(
  this: any,
  control: AbstractControl
): ValidationErrors | null {
  if (control.value != null && control.value < this.time) {
    return {
      severity: ErrorSeverityEnum.error,
      message: 'minTimeExceeded' + this.fieldName,
    };
  }

  return null;
}
